import { createStyles } from "@material-ui/core";
export var styles = function (_a) {
    return createStyles({
        root: {
            margin: '0 10px 0',
            lineHeight: '0'
        }
    });
};
